/**
 * Functionality for the HM Tab block.
 *
 * Adapted from the code provided on https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 */

/**
 * Change to tabs.
 *
 * @param {HTMLElement} tab Tab element.
 */
function activateTab( tab ) {
	const blockElement = tab.closest( '.dropdown-map' );
	const tabPanels = blockElement.querySelectorAll( '[role="panel"]' );

	blockElement
		.querySelectorAll( '[role="tab"][aria-selected="true"]' )
		.forEach( t => {
			t.setAttribute( 'aria-selected', false );
			t.setAttribute( 'tabindex', -1 );
			t.classList.remove( 'dropdown-map__select-item--active' );
		} );

	// Set this tab as selected
	tab.setAttribute( 'aria-selected', true );
	tab.setAttribute( 'tabindex', 0 );
	tab.classList.add( 'dropdown-map__select-item--active' );

	// Hide all tab panels
	tabPanels.forEach( p => {
		if ( p.getAttribute( 'id' ) === tab.getAttribute( 'id' ) ) {
			p.removeAttribute( 'hidden' );
		} else {
			p.setAttribute( 'hidden', true );
		}
	} );
}

/**
 * Initialize tab block.
 *
 * Ensure initial state is correct.
 *
 * @param {HTMLElement} blockElement Tab block.
 */
const initTabBlock = ( blockElement ) => {
	const tabs = blockElement.querySelectorAll( '[role="tab"]' );
	const tabList = blockElement.querySelector( '[role="tablist"]' );
	tabs.forEach( tab => {
		const panel = document.getElementById( tab.getAttribute( 'aria-controls' ) );
		const isActive = tab.classList.contains( 'dropdown-map__select-item--active' );

		if ( isActive ) {
			panel.removeAttribute( 'hidden' );
		} else {
			panel.setAttribute( 'hidden', true );
		}
	} );

	tabList.addEventListener( 'change', function () {
		let tab = tabList.options[tabList.selectedIndex];
		activateTab( tab );
		tabs.forEach( tab => {
			const panel = document.getElementById( tab.getAttribute( 'aria-controls' ) );
			const isActive = tab.classList.contains( 'dropdown-map__select-item--active' );
			if ( isActive ) {
				panel.removeAttribute( 'hidden' );
			} else {
				panel.setAttribute( 'hidden', true );
			}
		} );
	} );
};

/**
 * Kick it all off.
 */
function bootstrap() {
	document.querySelectorAll( '.dropdown-map' )
		.forEach( el => initTabBlock( el ) );
}

document.addEventListener( 'DOMContentLoaded', bootstrap );
